import { nodeGenerator } from './node_generator.js';
import { RectFilter } from '../caches/rect_filter_cache.js';
import { BaseBreakPoint } from '../break_points/base_break_point.js';
import { InlineBreakPoint } from '../break_points/inline_break_point.js';
import { SiblingBreakPoint } from '../break_points/sibling_break_point.js';
import { NodeRules } from '../caches/node_rule_cache.js';

/**
 * Yields permissible break points
 *
 * Based on CSS fragmentation Module level 3
 * https://www.w3.org/TR/css-break-3/
 */
export function* breakPointGenerator(root) {
  const rectFilter = new RectFilter();
  // Fix for older versions of safari
  rectFilter.acceptNode = rectFilter.acceptNode.bind(rectFilter);
  const nodeIterator = nodeGenerator(root, rectFilter);
  const nodeRules = new NodeRules();

  let currentBreakPoint = new SiblingBreakPoint({
    root,
    nodeRules,
    rectFilter,
  });
  let lastType;

  for (const [type, node] of nodeIterator) {
    switch (type) {
      case 'enter': {
        if (lastType === 'inline') {
          const lastBreakPoint = currentBreakPoint;
          yield currentBreakPoint;

          currentBreakPoint = new SiblingBreakPoint({
            root,
            nodeRules,
            rectFilter,
          });
          currentBreakPoint.trailingNodes.unshift(lastBreakPoint.lastNode);
        }
        currentBreakPoint.leadingNodes.push(node);
        break;
      }

      case 'inline': {
        if (lastType === 'exit') {
          currentBreakPoint.leadingNodes.push(node);
        }
        if (lastType !== type) {
          yield currentBreakPoint;
          currentBreakPoint = new InlineBreakPoint({
            root,
            nodeRules,
            rectFilter,
          });
        }
        currentBreakPoint.nodes.push(node);
        break;
      }

      case 'exit': {
        if (lastType !== type) {
          yield currentBreakPoint;
          currentBreakPoint = new SiblingBreakPoint({
            root,
            nodeRules,
            rectFilter,
          });
        }
        currentBreakPoint.trailingNodes.unshift(node);
        break;
      }

      default:
        throw new Error(`unexpected node type ${type}`);
    }

    lastType = type;
  }

  yield currentBreakPoint;

  // If the last node is a text node and we are overflowing we may need to force a breakpoint
  yield new BaseBreakPoint({ root, nodeRules, rectFilter });
}
